import { API } from "@swivl-mono/api-helper";
import { Channel, EscalationInterface, SessionInterface } from "@swivl-mono/types";

import CallModel from "../../CallModel/Call.Model";
import { Member } from "../../Member/Member.Current";
import NotificationsModel from "../../Notifications/Notifications.Model";
import PendingUpdatesModel, { PendingUpdateType } from "../../Pending/Pending.Model";
import { UsersModel } from "../Users.Model";

export const UsersModeEscalationMethods = {
  loadAllEscalations: async () => {
    const escalations = await API.Escalations.getAllActiveEscalations(Member.orgId);
    UsersModel.setUserSessionOrEscalation(undefined, undefined, escalations);
  },
  loadUnacknowledgedEscalations: async () => {
    const escalations = await API.Escalations.getUnacknowledgedEscalations(Member.orgId, Member.id!);
    UsersModel.setUserSessionOrEscalation(undefined, undefined, escalations);
  },
  escalationUpdated: (escalation: EscalationInterface) => {
    UsersModel.setUserSessionOrEscalation(undefined, undefined, [escalation]);
  },

  ignoreEscalation: (escalation: EscalationInterface) => {
    PendingUpdatesModel.addPendingUpdate(PendingUpdateType.SESSION_ESCALATION, escalation.sessionId);

    return API.Escalations.rejectEscalation(Member.orgId!, escalation.sessionId!, escalation.id, Member.id!)
      .then((escalationData) => {
        PendingUpdatesModel.removePendingUpdate(PendingUpdateType.SESSION_ESCALATION, escalation.sessionId);
        UsersModel.setUserSessionOrEscalation(undefined, undefined, [escalationData.escalation]);
        NotificationsModel.escalationIgnoredCallback(escalationData.escalation);
        if (escalation.channel === Channel.VOICE) {
          CallModel.ignoreVoiceEscalation(escalationData.escalation);
        }
        return escalationData.escalation;
      })
      .catch((error) => {
        PendingUpdatesModel.removePendingUpdate(PendingUpdateType.SESSION_ESCALATION, escalation.sessionId);
        NotificationsModel.escalationIgnoredCallback(escalation);
      });
  },

  acceptEscalation: (escalation: EscalationInterface) => {
    PendingUpdatesModel.addPendingUpdate(PendingUpdateType.SESSION_ESCALATION, escalation.sessionId);
    return API.Escalations.acceptEscalation(Member.orgId!, escalation.sessionId!, escalation.id, Member.id!)
      .then((escalationData) => {
        PendingUpdatesModel.removePendingUpdate(PendingUpdateType.SESSION_ESCALATION, escalation.sessionId);
        UsersModel.setUserSessionOrEscalation(undefined, undefined, [escalationData.escalation]);
        NotificationsModel.escalationAcceptedCallback(escalationData.escalation);
        if (escalation.channel === Channel.VOICE) {
          CallModel.acceptedVoiceEscalation(escalationData.escalation);
        }
        return escalationData.escalation;
      })
      .catch((error) => {
        PendingUpdatesModel.removePendingUpdate(PendingUpdateType.SESSION_ESCALATION, escalation.sessionId);

        NotificationsModel.escalationAcceptedCallback(escalation);

        return Promise.reject(error);
      });
  },
  acknowledgeEscalation: (escalation: EscalationInterface) => {
    PendingUpdatesModel.addPendingUpdate(PendingUpdateType.SESSION_ESCALATION, escalation.sessionId);
    return API.Escalations.acknowledgeEscalation(Member.orgId!, escalation.sessionId, escalation.id, Member.id!)
      .then((escalationData) => {
        PendingUpdatesModel.removePendingUpdate(PendingUpdateType.SESSION_ESCALATION, escalation.sessionId);
        UsersModel.setUserSessionOrEscalation(undefined, undefined, [escalationData.escalation]);
        return escalationData.escalation;
      })
      .catch((error) => {
        PendingUpdatesModel.removePendingUpdate(PendingUpdateType.SESSION_ESCALATION, escalation.sessionId);
      });
  },
};
